module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-124.0aecc7e7.svg";